import React from "react";
import { Button } from "@glamcorner/components/lib/core/components/Button";
import { ItemLimit, TiersAccessible } from "@glamcorner/gc-types/lib/subscription";

import "./plan.scss";


export type PlanType = {
  price: number;
  itemLimit: ItemLimit;
  tiersAccessible: TiersAccessible;
  name: string;
  onClick: () => void;
  flagText?: string;
};

export type PlanTypeInstance = {
  price: number;
  itemLimit: ItemLimit;
  tiersAccessible: TiersAccessible;
  onClick: () => void;
};

const Plan: React.FC<PlanType> = ({ price, itemLimit, name, onClick, flagText, children }) => {
  return (
    <div className="choosePlan-plan__wrapper">
      <div className="choosePlan-plan__heading">
        <div className="choosePlan-plan__title">
          <div className="choosePlan-plan__name">{name}</div>
          {flagText ? <div className="choosePlan-plan__flag">{flagText}</div> : undefined}
        </div>
        <div className="choosePlan-plan__price-item">
          <span className="choosePlan-plan__price">${price}</span>
          <span className="choosePlan-plan__items">for {itemLimit} items</span>
        </div>
      </div>

      <div className="choosePlan-plan__body">{children}</div>
      <Button text={`Join ${name} plan`} onClick={onClick} />

      <div className="choosePlan-plan__pause-or-cancel">Pause or Cancel anytime</div>
    </div>
  );
};

export default Plan;
